export interface IUtilityLinkPartner {
  partner: "uapi" | "bayou";
  utilities: IUtilitLinkUtility[];
}

export interface IUtilitLinkUtility {
  utilityName: string;
  utilityCode: string;
}

export interface IUtilityLink {
  partners: IUtilityLinkPartner[];
}

const uapiConfig: IUtilityLinkPartner = {
  partner: "uapi",
  utilities: [
    { utilityCode: "AEPIM", utilityName: "Indiana Michigan Power" },
    { utilityCode: "APS", utilityName: "Arizona Public Service Company" },
    {
      utilityCode: "BLUEWATER",
      utilityName: "Bluewater Power Distribution Corporation",
    },
    { utilityCode: "ConEd", utilityName: "Consolidated Edison New York" },
    { utilityCode: "CONSUMERSENERGY", utilityName: "Consumers Energy" },
    { utilityCode: "DEMO", utilityName: "Demonstration Utility" },
    { utilityCode: "EPE", utilityName: "El Paso Electric Company" },
    { utilityCode: "ESSEX", utilityName: "Essex Powerlines" },
    { utilityCode: "EVRSRC", utilityName: "Eversource" },
    { utilityCode: "EVRSRCMA", utilityName: "Eversource Massachusetts" },
    { utilityCode: "FCU", utilityName: "Fort Collins Utilities" },
    {
      utilityCode: "IEDR",
      utilityName: "Integrated Energy Data Resource Program",
    },
    {
      utilityCode: "LADWP",
      utilityName: "Los Angeles Department of Water & Power",
    },
    { utilityCode: "LAKEFRONT", utilityName: "Lakefront Utilities Inc." },
    { utilityCode: "NATGD", utilityName: "National Grid" },
    { utilityCode: "NGNY", utilityName: "National Grid New York" },
    { utilityCode: "PCE", utilityName: "Peninsula Clean Energy" },
    { utilityCode: "PG&E", utilityName: "Pacific Gas and Electric" },
    { utilityCode: "SCE", utilityName: "Southern California Edison" },
    { utilityCode: "SDG&E", utilityName: "San Diego Gas and Electric" },
    { utilityCode: "SoCalGas", utilityName: "Southern California Gas Company" },
    { utilityCode: "SSMPUC", utilityName: "PUC Distribution Inc." },
    {
      utilityCode: "SWEPCO",
      utilityName: "Southwestern Electric Power Company",
    },
    {
      utilityCode: "WELLAND",
      utilityName: "Welland Hydro-Electric System Corp",
    },
  ],
};

const bayouConfig: IUtilityLinkPartner = {
  partner: "bayou",
  utilities: [
    { utilityCode: "aes_indiana", utilityName: "AES Indiana" },
    { utilityCode: "aes_ohio", utilityName: "AES Ohio" },
    { utilityCode: "alabama_power", utilityName: "Alabama Power" },
    { utilityCode: "enormity_alliant_energy", utilityName: "Alliant Energy" },
    { utilityCode: "ameren", utilityName: "Ameren" },
    {
      utilityCode: "american_electric_power_ohio",
      utilityName: "American Electric Power Ohio",
    },
    {
      utilityCode: "american_electric_power_texas",
      utilityName: "American Electric Power Texas",
    },
    { utilityCode: "appalachian_power", utilityName: "Appalachian Power" },
    {
      utilityCode: "arizona_public_service",
      utilityName: "Arizona Public Service",
    },
    {
      utilityCode: "atlantic_city_electric",
      utilityName: "Atlantic City Electric",
    },
    { utilityCode: "austin_utilities", utilityName: "Austin Utilities" },
    { utilityCode: "avista", utilityName: "Avista" },
    {
      utilityCode: "baltimore_gas_and_electric",
      utilityName: "Baltimore Gas and Electric",
    },
    { utilityCode: "center_point_energy", utilityName: "Center Point Energy" },
    { utilityCode: "central_hudson", utilityName: "Central Hudson" },
    { utilityCode: "central_maine_power", utilityName: "Central Maine Power" },
    { utilityCode: "citizens_energy", utilityName: "Citizens Energy" },
    { utilityCode: "cleco_power", utilityName: "Cleco Power" },
    {
      utilityCode: "colorado_springs_utilities",
      utilityName: "Colorado Springs Utilities",
    },
    { utilityCode: "commonwealth_edison", utilityName: "Commonwealth Edison" },
    { utilityCode: "con_edison", utilityName: "Con Edison" },
    { utilityCode: "consumers_energy", utilityName: "Consumers Energy" },
    { utilityCode: "cps", utilityName: "CPS" },
    { utilityCode: "delmarva_power", utilityName: "Delmarva Power" },
    {
      utilityCode: "dominion_energy_idaho",
      utilityName: "Dominion Energy Idaho",
    },
    {
      utilityCode: "dominion_energy_north_carolina_electric",
      utilityName: "Dominion Energy North Carolina Electric",
    },
    {
      utilityCode: "dominion_energy_north_carolina_gas",
      utilityName: "Dominion Energy North Carolina Gas",
    },
    {
      utilityCode: "dominion_energy_ohio",
      utilityName: "Dominion Energy Ohio",
    },
    {
      utilityCode: "dominion_energy_south_carolina",
      utilityName: "Dominion Energy South Carolina",
    },
    {
      utilityCode: "dominion_energy_utah",
      utilityName: "Dominion Energy Utah",
    },
    {
      utilityCode: "dominion_energy_virginia",
      utilityName: "Dominion Energy Virginia",
    },
    {
      utilityCode: "dominion_energy_wyoming",
      utilityName: "Dominion Energy Wyoming",
    },
    { utilityCode: "dte_energy", utilityName: "DTE Energy" },
    { utilityCode: "duke_energy", utilityName: "Duke Energy" },
    { utilityCode: "duquesne_light", utilityName: "Duquesne Light" },
    { utilityCode: "el_paso_electric", utilityName: "El Paso Electric" },
    { utilityCode: "entergy", utilityName: "Entergy" },
    { utilityCode: "evergy", utilityName: "Evergy" },
    { utilityCode: "eversource", utilityName: "Eversource" },
    {
      utilityCode: "florida_power_and_light",
      utilityName: "Florida Power and Light",
    },
    { utilityCode: "georgia_power", utilityName: "Georgia Power" },
    {
      utilityCode: "green_mountain_power",
      utilityName: "Green Mountain Power",
    },
    { utilityCode: "gulf_power", utilityName: "Gulf Power" },
    { utilityCode: "hawaiian_electric", utilityName: "Hawaiian Electric" },
    { utilityCode: "idaho_power", utilityName: "Idaho Power" },
    {
      utilityCode: "indiana_michigan_power",
      utilityName: "Indiana Michigan Power",
    },
    {
      utilityCode: "jersey_central_power_and_light",
      utilityName: "Jersey Central Power and Light",
    },
    { utilityCode: "kentucky_power", utilityName: "Kentucky Power" },
    { utilityCode: "kentucky_utilities", utilityName: "Kentucky Utilities" },
    { utilityCode: "liberty_utilities", utilityName: "Liberty Utilities" },
    {
      utilityCode: "los_angeles_department_of_water_and_power",
      utilityName: "Los Angeles Department of Water and Power",
    },
    {
      utilityCode: "madison_gas_and_electric",
      utilityName: "Madison Gas and Electric",
    },
    {
      utilityCode: "memphis_light_gas_and_water",
      utilityName: "Memphis Light, Gas and Water",
    },
    { utilityCode: "metropolitan_edison", utilityName: "Metropolitan Edison" },
    { utilityCode: "midamerican_energy", utilityName: "MidAmerican Energy" },
    {
      utilityCode: "middle_tennessee_electric",
      utilityName: "Middle Tennessee Electric",
    },
    { utilityCode: "mississippi_power", utilityName: "Mississippi Power" },
    {
      utilityCode: "modesto_irrigation_district",
      utilityName: "Modesto Irrigation District",
    },
    { utilityCode: "mon_power", utilityName: "Mon Power" },
    {
      utilityCode: "nashville_electric_service",
      utilityName: "Nashville Electric Service",
    },
    {
      utilityCode: "national_grid_massachusetts",
      utilityName: "National Grid Massachusetts",
    },
    {
      utilityCode: "national_grid_new_york",
      utilityName: "National Grid New York",
    },
    { utilityCode: "northwestern_energy", utilityName: "NorthWestern Energy" },
    { utilityCode: "nv_energy", utilityName: "NV Energy" },
    { utilityCode: "nyseg", utilityName: "NYSEG" },
    { utilityCode: "ohio_edison", utilityName: "Ohio Edison" },
    {
      utilityCode: "oklahoma_gas_and_electric",
      utilityName: "Oklahoma Gas and Electric",
    },
    { utilityCode: "orange_and_rockland", utilityName: "Orange and Rockland" },
    {
      utilityCode: "orlando_utilities_commission",
      utilityName: "Orlando Utilities Commission",
    },
    {
      utilityCode: "pacific_gas_and_electric",
      utilityName: "Pacific Gas and Electric",
    },
    { utilityCode: "pacific_power", utilityName: "Pacific Power" },
    { utilityCode: "peco", utilityName: "PECO" },
    { utilityCode: "penelec", utilityName: "Penelec" },
    { utilityCode: "penn_power", utilityName: "Penn Power" },
    { utilityCode: "pepco", utilityName: "PEPCO" },
    {
      utilityCode: "portland_general_electric",
      utilityName: "Portland General Electric",
    },
    { utilityCode: "potomac_edison", utilityName: "Potomac Edison" },
    { utilityCode: "ppl_electric", utilityName: "PPL Electric" },
    { utilityCode: "pseg_long_island", utilityName: "PSEG Long Island" },
    { utilityCode: "pseg_new_jersey", utilityName: "PSEG New Jersey" },
    {
      utilityCode: "public_service_company_of_new_mexico",
      utilityName: "Public Service Company of New Mexico",
    },
    {
      utilityCode: "public_service_company_of_oklahoma",
      utilityName: "Public Service Company of Oklahoma",
    },
    { utilityCode: "puget_sound_energy", utilityName: "Puget Sound Energy" },
    { utilityCode: "rhode_island_energy", utilityName: "Rhode Island Energy" },
    {
      utilityCode: "rochester_gas_and_electric",
      utilityName: "Rochester Gas and Electric",
    },
    {
      utilityCode: "rocky_mountain_power",
      utilityName: "Rocky Mountain Power",
    },
    {
      utilityCode: "sacramento_municipal_utility_district",
      utilityName: "Sacramento Municipal Utility District",
    },
    { utilityCode: "salt_river_project", utilityName: "Salt River Project" },
    {
      utilityCode: "san_diego_gas_and_electric",
      utilityName: "San Diego Gas and Electric",
    },
    { utilityCode: "seattle_city_light", utilityName: "Seattle City Light" },
    {
      utilityCode: "southern_california_edison",
      utilityName: "Southern California Edison",
    },
    {
      utilityCode: "southern_california_gas",
      utilityName: "Southern California Gas",
    },
    {
      utilityCode: "southwestern_electric_power_company",
      utilityName: "Southwestern Electric Power Company",
    },
    { utilityCode: "speculoos_power", utilityName: "Speculoos Power" },
    { utilityCode: "tampa_electric", utilityName: "Tampa Electric" },
    {
      utilityCode: "the_illuminating_company",
      utilityName: "The Illuminating Company",
    },
    {
      utilityCode: "the_united_illuminating_company",
      utilityName: "The United Illuminating Company",
    },
    { utilityCode: "toledo_edison", utilityName: "Toledo Edison" },
    {
      utilityCode: "tucson_electric_power",
      utilityName: "Tucson Electric Power",
    },
    { utilityCode: "united_power", utilityName: "United Power" },
    { utilityCode: "unitil", utilityName: "Unitil" },
    { utilityCode: "versant_power", utilityName: "Versant Power" },
    { utilityCode: "we_energies", utilityName: "WE Energies" },
    { utilityCode: "west_penn_power", utilityName: "West Penn Power" },
    {
      utilityCode: "wisconsin_public_service",
      utilityName: "Wisconsin Public Service",
    },
    { utilityCode: "xcel_energy", utilityName: "Xcel Energy" },
  ],
};

export const utilityLinkConfg: IUtilityLink = {
  partners: [uapiConfig, bayouConfig],
};


export const matchUtilityByName = (
  name?: string
): IUtilitLinkUtility | undefined => {
  const normalized = name?.trim().toLowerCase();
  console.log("normalized name " + normalized)
  if (!normalized) return undefined;
  return utilityLinkConfg.partners
    .flatMap((p) => p.utilities)
    .find((u) => u.utilityName.trim().toLowerCase() === normalized);
};
